import { ErrorOutline, KeyboardArrowDown } from "@mui/icons-material";
import { Button, CircularProgress, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import CryptoJS from "crypto-js";
import generatecode from "../utils/generateCode";
import decryptApi from "../utils/decryptApi";
import encryptApi from "../utils/encryptApi";


const EditChannelModal = ({ open, setOpen, channels, setChannels, channel_data, closeMenu, index, channelUpdatedModal, setOpenChannelUpdatedModal }) => {
  const [loader, setLoader] = useState(false);
  const [error_msg, setErrormsg] = useState(null);
  const [code_sent, setCodeSent] = useState(false);
  const [channel, setChannel] = useState(
    {
    channel_id:   channel_data.ch_id.S,
      label: channel_data.label.S,
      last_updated: channel_data.last_updated.S,
      status: channel_data.status.S,
      type: channel_data.type.S,
      value: channel_data.value.S,
      organization_id: JSON.parse(localStorage.getItem("organization"))
        .orgId.S,
      slack_id: "",
      api_key: "",
      front_id: "",
    }
  );

  const [code, setCode] = useState(null)
   const [timeLeft, setTimeLeft] = useState(0);
  
  useEffect(()=> {
    setCode(generatecode())
    setCodeSent(false)
    setErrormsg(null)
},[channel.type])


useEffect(() => {
  if (timeLeft === 0) {
    setCode(generatecode())
  };

  const intervalId = setInterval(() => {
    setTimeLeft((prevTime) => prevTime - 1);
  }, 1000);

  return () => clearInterval(intervalId); // Cleanup on unmount or re-render

}, [timeLeft]);

  async function sendEmailVerificationLink() {
    setErrormsg(null);
 const ciphertext = CryptoJS.AES.encrypt(code, process.env.REACT_APP_TWILANSWER_SECRET).toString();
    setLoader(true);
    try {
      let response = await axios.post(
        process.env.REACT_APP_BACKEND_URL +
          "email/send-email-verification-code",
        {
          email: channel.type === "email" && channel.value,
          toName: channel.label,
          code: await encryptApi(code),
        }
      );
      console.log(response);
      setCodeSent(true);
      setTimeLeft(60)

      setLoader(false);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrormsg(error.response.data.message);
      }
      setLoader(false);
    }
  }

  function decodeToken(token) {
      console.log(token)
          try {
            const decoded = jwtDecode(token);
            console.log({decoded})
            return decoded.api_key;
          } catch (error) {
            console.error('Invalid token:', error);
            return null;
          }
        }
  

  async function sendPhoneVerificationText() {
    setErrormsg(null);

    setLoader(true);
     const ciphertext = CryptoJS.AES.encrypt(code, process.env.REACT_APP_TWILANSWER_SECRET).toString();
    try {
      let response = await axios.post(
        process.env.REACT_APP_BACKEND_URL +
          "twilio/read-num-aloud",
          {
            fromNumber: JSON.parse(localStorage.getItem("organization"))
              .twilio_integration?.M.primary_phone.S,
            forwarding_number: channel.value,
            code: await encryptApi(code),
            account_sid: JSON.parse(localStorage.getItem("organization"))
              .twilio_integration.M.account_sid.S,
            api_key: (JSON.parse(localStorage.getItem("organization")).twilio_integration
              .M.api_key.S),
          }
      );
      console.log(response);
      setCodeSent(true);
      setTimeLeft(60)

      setLoader(false);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrormsg(error.response.data.error);
      }
      setLoader(false);
    }
  }

    async function sendPhoneVerificationSms() {
      setErrormsg(null);
   const ciphertext = CryptoJS.AES.encrypt(code, process.env.REACT_APP_TWILANSWER_SECRET).toString();
      setLoader(true);
      try {
        let response = await axios.post(
          process.env.REACT_APP_BACKEND_URL +
            "twilio/send-text-message",
            {
              fromNumber: JSON.parse(localStorage.getItem("organization"))
                .twilio_integration?.M.primary_phone.S,
                toNumber: channel.value,
              code: await encryptApi(code),
            }
        );
        console.log(response);
        setCodeSent(true);
        setTimeLeft(60)
  
        setLoader(false);
      } catch (error) {
        console.log(error);
        if (error.response && error.response.data) {
          console.error("Response data:", error.response.data);
          setErrormsg(error.response.data.error);
        }
        setLoader(false);
      }
    }


  const editChannel = async () => {
      let check= await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
                      userId: JSON.parse(localStorage.getItem('user')).userId.S
                  });
                  
                  if (check.status === 200) {
                    const user___ = check.data.user;
                    
              
                    if(user___.relatedOrgs.L?.find((e)=> e?.M.org_id?.S === JSON.parse(localStorage.getItem('organization')).orgId.S)){
                        
                      if (
                        JSON.parse(localStorage.getItem("organization")).channels?.L.find(
                          (e) => e.M.type.S === channel.type && e.M.value.S === channel.value && e.M.value.S !== 'N/A'
                          && e.M.type.S !== 'front' && e.M.type.S !== 'slack' && e.M.ch_id.S !== channel.channel_id
                        )
                      ) {
                        setErrormsg('Another channel with '+channel.type +" already exist");
                      }else{
                  
                        if (channel.type === 'front' || channel.type === 'slack' || channel?.code === code){
                          try {
                  
                            setLoader(true)
                    
                    
                    
                    
                            let channel_data = await axios.post(
                              process.env.REACT_APP_BACKEND_URL + "update-channel", channel
                              
                            );
                      
                            console.log(channel_data);
                      
                            
                      
                            localStorage.setItem(
                              "organization",
                              JSON.stringify(channel_data.data.updatedItem)
                            );
                      
                            setChannels(channel_data.data.updatedItem.channels.L)
                           
                            if(channel.type === 'email'){
                              setOpenChannelUpdatedModal(true)
                            }
                  
                            if(channel.type === 'forward_number'){
                              setOpenChannelUpdatedModal(true)
                            }
                  
                            if(channel.type === 'sms'){
                              setOpenChannelUpdatedModal(true)
                            }
                            if(channel.type === 'front'){
                              setOpenChannelUpdatedModal(true)
                            }
                            if(channel.type === 'slack'){
                              setOpenChannelUpdatedModal(true)
                            }
                  
                            setOpen(false)
                            setLoader(false)
                            setErrormsg(null)
                            closeMenu(index)
                          }  catch (error) {
                            console.log(error)
                            if (error.response && error.response.data) {
                              console.error("Response data:", error.response.data);
                              setErrormsg(error.response.data.message)
                            }
                            setLoader(false)
                          }
                        }else{
                          setErrormsg("verification code does not match");
                        }
                       
                      }
                    }else{
                      window.location.reload()
                    }
          
                  }

   
  };


  //  useEffect(() => {
   
  //       const globalKeyListener = (e) => {
  //         console.log("Global key event:", e.key);
  //         if(document.getElementById('input') === document.activeElement){
  //           if (e.key === 'd' || e.key === 'D' || e.key === 'E' || e.key === 'e') {
  //             // Manually update the input value with 'd'
  //             setChannel((prevChannel) => ({
  //               ...prevChannel,
  //               label: prevChannel.label + e.key,
  //             }));
  //             // Prevent the default action of the 'd' key
  //             document.getElementById('input').focus()
  //             e.preventDefault();
  //           }
  //         }
  //       };
      
  //       document.addEventListener("keydown", globalKeyListener);
      
  //       return () => {
  //         document.removeEventListener("keydown", globalKeyListener);
  //       };
  //     }, []);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"sm"}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here

      }}
    >
      <div className="px-8 py-6">
        <div className="lg:text-[16px] text-[14px]  font-semibold mb-2">
          {" "}
          Edit Channel
        </div>
        {error_msg && (
            <div className="flex items-center text-red-500 lg:text-[13px] text-[12px] mb-2  font-semibold ">
              <ErrorOutline sx={{ fontSize: "", mr: '1px' }} /> {error_msg}
            </div>
          )}
        <div className="flex justify-center">
          <div className="space-y-5">
            <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0 ">
              <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                Channel Type{" "}
                <img
                  src="/icons/tooltip.png"
                  className="w-[15px] lg:ml-3 ml-1"
                />
              </div>

              <div className="lg:w-[200px]">
                <Select
                  IconComponent={KeyboardArrowDown}
                  fullWidth
                  defaultValue={channel.type}
                  value={channel.type}
                  onChange={(e) => {
                    setChannel({ ...channel, type: e.target.value });
                  }}
                  className="mb-2 bg-[#F7F7F8]"
                  sx={{
                    fontSize: { lg: "14px", xs: "12px" },
                    padding: "4px 8px", // Adjust padding here
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "& .MuiSelect-select": {
                      padding: "4px 8px", // Adjust padding for the text inside Select
                    },
                  }}
                >
                  <MenuItem value="email">Email</MenuItem>
                  <MenuItem value="sms">SMS</MenuItem>
                  <MenuItem value="forward_number">Forward Number</MenuItem>
                  <MenuItem value="front">Front Channel</MenuItem>
                  <MenuItem value="slack">Slack Channel</MenuItem>
                </Select>
              </div>
            </div>
            <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
              <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                Channel Nickname{" "}
                <img
                  src="/icons/tooltip.png"
                  className="w-[15px] lg:ml-3 ml-1"
                />
              </div>

              <div className="lg:w-[200px]">
                <InputBase
                 id='input'
                 value={channel.label}
                 onChange={(e) => {
                   setChannel({ ...channel, label: e.target.value });
                 }}
                  sx={{
                    bgcolor: "#F7F7F8",
                    width: "100%",
                    px: 2,
                    fontSize: { lg: "14px", xs: "12px" },
                  }}
                />
              </div>
            </div>
          {channel.type === "email" && (
                     <>
                       <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                         <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                           Email Address
                           <img
                             src="/icons/tooltip.png"
                             className="w-[15px] lg:ml-3 ml-1"
                           />
                         </div>
         
                         <div className="lg:w-[200px] mr-2">
                           <InputBase
                             value={channel.value}
                             onChange={(e) => {
                               setChannel({ ...channel, value: e.target.value });
                             }}
                             sx={{
                               bgcolor: "#F7F7F8",
                               width: "100%",
                               px: 2,
                               fontSize: { lg: "14px", xs: "12px" },
                             }}
                           />
                         </div>
         
                          
                             <div className="flex lg:justify-center mt-2 lg:mt-2 relative  ">
                                                 {timeLeft >= 1 ? (
                                                   <Button
                                                   sx={{
                                                     textTransform: "none",
                                                     bgcolor: "#605BFF",
                                                     color: "white",
                                                     py: "1px",
                                                     px: "10px",
                                                     borderRadius: "7px",
                                                     fontSize: { lg: "14px", xs: "12px" },
                                                   }}
                                                 >
                                                   Expires {timeLeft}
                                                 </Button>
                                                 ) : (
                                                
                             <Button
                               sx={{
                                 textTransform: "none",
                                 bgcolor: "#605BFF",
                                 color: "white",
                                 py: "1px",
                                 px: "1px",
                                 borderRadius: "7px",
                                 fontSize: { lg: "14px", xs: "12px" },
                               }}
                               onClick={sendEmailVerificationLink}
                             >
                               Verify
                             </Button>
                                                 )}
                             </div>
                       </div>
                       {code_sent && (
         
                         <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                           <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                             Verification Code
                             <img
                               src="/icons/tooltip.png"
                               className="w-[15px] lg:ml-3 ml-1"
                             />
                           </div>
           
                           <div className="lg:w-[200px]">
                           <InputBase
                                   value={channel.code}
                                   onChange={(e) => {
                                     setChannel({ ...channel, code: e.target.value });
                                   }}
                                   placeholder="enter verification code"
                                   sx={{
                                     bgcolor: "#F7F7F8",
                                     width: "100%",
                                     px: 2,
                                     fontSize: { lg: "14px", xs: "12px" },
                                   }}
                                 />
                           </div>
           
                           
                            
                         </div>
                       )}
                       </>
                     )}
            {channel.type === "sms" && (
                      <>
                        <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                          <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                            Phone Number
                            <img
                              src="/icons/tooltip.png"
                              className="w-[15px] lg:ml-3 ml-1"
                            />
                          </div>
          
                          <div className="lg:w-[200px]">
                            <InputBase
                              value={channel.value}
                              onChange={(e) => {
                                setChannel({ ...channel, value: e.target.value });
                              }}
                              sx={{
                                bgcolor: "#F7F7F8",
                                width: "100%",
                                px: 2,
                                fontSize: { lg: "14px", xs: "12px" },
                              }}
                            />
                          </div>
          
                        
                              <div className="flex lg:justify-center mt-2 lg:mt-2 relative  ">
                                                   {timeLeft >= 1 ? (
                                                     <Button
                                                     sx={{
                                                       textTransform: "none",
                                                       bgcolor: "#605BFF",
                                                       color: "white",
                                                       py: "1px",
                                                       px: "10px",
                                                       borderRadius: "7px",
                                                       fontSize: { lg: "14px", xs: "12px" },
                                                     }}
                                                   >
                                                     Expires {timeLeft}
                                                   </Button>
                                                   ) : (
                                                   
                              <Button
                                sx={{
                                  textTransform: "none",
                                  bgcolor: "#605BFF",
                                  color: "white",
                                  py: "1px",
                                  px: "1px",
                                  borderRadius: "7px",
                                  fontSize: { lg: "14px", xs: "12px" },
                                }}
                                onClick={sendPhoneVerificationSms}
                              >
                                Verify
                              </Button>
                                                   )}
                              </div>
                        </div>
          
                        {code_sent && (
          
                        <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                          <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                            Verification Code
                            <img
                              src="/icons/tooltip.png"
                              className="w-[15px] lg:ml-3 ml-1"
                            />
                          </div>
          
                          <div className="lg:w-[200px]">
                          <InputBase
                                  value={channel.code}
                                  onChange={(e) => {
                                    setChannel({ ...channel, code: e.target.value });
                                  }}
                                  placeholder="enter verification code"
                                  sx={{
                                    bgcolor: "#F7F7F8",
                                    width: "100%",
                                    px: 2,
                                    fontSize: { lg: "14px", xs: "12px" },
                                  }}
                                />
                          </div>
          
                          
                           
                        </div>
                      )}
                      </>
                      )}
 {channel.type === "forward_number" && (
            <>
              <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                  Phone Number
                  <img
                    src="/icons/tooltip.png"
                    className="w-[15px] lg:ml-3 ml-1"
                  />
                </div>

                <div className="lg:w-[200px]">
                  <InputBase
                    value={channel.value}
                    onChange={(e) => {
                      setChannel({ ...channel, value: e.target.value });
                    }}
                    sx={{
                      bgcolor: "#F7F7F8",
                      width: "100%",
                      px: 2,
                      fontSize: { lg: "14px", xs: "12px" },
                    }}
                  />
                </div>

            
                    <div className="flex lg:justify-center mt-2 lg:mt-2 relative  ">
                                         {timeLeft >= 1 ? (
                                           <Button
                                           sx={{
                                             textTransform: "none",
                                             bgcolor: "#605BFF",
                                             color: "white",
                                             py: "1px",
                                             px: "10px",
                                             borderRadius: "7px",
                                             fontSize: { lg: "14px", xs: "12px" },
                                           }}
                                         >
                                           Expires {timeLeft}
                                         </Button>
                                         ) : (
                                          
                    <Button
                      sx={{
                        textTransform: "none",
                        bgcolor: "#605BFF",
                        color: "white",
                        py: "1px",
                        px: "1px",
                        borderRadius: "7px",
                        fontSize: { lg: "14px", xs: "12px" },
                      }}
                      onClick={sendPhoneVerificationText}
                    >
                      Verify
                    </Button>
                                         )}
                    </div>
              </div>
              
              {code_sent && (

                <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                  <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                    Verification Code
                    <img
                      src="/icons/tooltip.png"
                      className="w-[15px] lg:ml-3 ml-1"
                    />
                  </div>
  
                  <div className="lg:w-[200px]">
                  <InputBase
                          value={channel.code}
                          onChange={(e) => {
                            setChannel({ ...channel, code: e.target.value });
                          }}
                          placeholder="enter verification code"
                          sx={{
                            bgcolor: "#F7F7F8",
                            width: "100%",
                            px: 2,
                            fontSize: { lg: "14px", xs: "12px" },
                          }}
                        />
                  </div>
  
                  
                   
                </div>
              )}
              </>
            )}


          

            <div className="flex justify-center pt-6 pb-4 space-x-2">
              <Button
                sx={{
                  textTransform: "none",
                  color: "#605BFF",
                  bgcolor: "white",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                onClick={() => {
                  setOpen(false)
                }}
              >
                Close
              </Button>

              <Button
                sx={{
                  textTransform: "none",
                  bgcolor: "#605BFF",
                  color: "white",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                onClick={editChannel}
                disabled={loader}
              >
                 {loader? (
                          <CircularProgress
                            size={"1.3rem"}
                            sx={{ color: "white" }}
                          />
                        ) : (
                          " Save"
                        )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default EditChannelModal;
